(function(){
  var EN=(document.documentElement.lang||'fr').slice(0,2)!=='fr';
  function fmt(t){
    t=String(t||'');
    if(EN){var m=t.match(/(\d+)[.,](\d\d)(?!\d)/);return m?('$'+m[1]+'.'+m[2]).replace(/\.00$/,''):t;}
    return t.replace(/(\d)\.(\d\d)(?!\d)/g,'$1,$2').replace(/,00(?!\d)/g,'').replace(/\s*\$/,' $');
  }
  var t=document.querySelector('[data-menu-toggle]'),m=document.getElementById('mobile-nav');
  if(t&&m){t.addEventListener('click',function(){var o=t.getAttribute('aria-expanded')==='true';t.setAttribute('aria-expanded',String(!o));m.hidden=o;});}
  document.querySelectorAll('[data-auto-submit]').forEach(function(s){s.addEventListener('change',function(){if(s.form){s.form.submit();}});});
  document.querySelectorAll('[data-product-form]').forEach(function(f){
    var sel=f.querySelector('.js-variant');if(!sel){return;}
    var scope=f.closest('[data-product]')||document;
    var price=scope.querySelector('.js-price'),was=scope.querySelector('.js-was'),btn=f.querySelector('[data-add]'),soldTxt=f.getAttribute('data-sold'),addTxt=f.getAttribute('data-add-label');
    function upd(){
      var o=sel.options[sel.selectedIndex];if(!o){return;}
      if(price){price.textContent=fmt(o.getAttribute('data-price'));}
      if(was){var w=o.getAttribute('data-compare');was.textContent=w?fmt(w):'';was.hidden=!w;}
      if(btn){var ok=o.getAttribute('data-available')==='true';btn.disabled=!ok;btn.textContent=ok?addTxt:soldTxt;}
      try{var u=new URL(window.location.href);u.searchParams.set('variant',sel.value);window.history.replaceState({},'',u);}catch(e){}
    }
    sel.addEventListener('change',upd);
  });
})();
